import { Component, OnInit } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
// import * as am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
// import * as am4geodata_franceLow from "@amcharts/amcharts4-geodata/franceLow";
import am4geodata_usaLow from "@amcharts/amcharts4-geodata/usaLow";

@Component({
  selector: "app-map-chart",
  templateUrl: "./map-chart.component.html",
  styleUrls: ["./map-chart.component.scss"],
})
export class MapChartComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    var map = am4core.create("chartdiv", am4maps.MapChart);
    let data = {
      AL: ["albaniaLow", "albaniaHigh"],
      DZ: ["algeriaLow", "algeriaHigh"],
      AS: ["americanSamoaLow", "americanSamoaHigh"],
      AD: ["andorraLow", "andorraHigh"],
      AO: ["angolaLow", "angolaHigh"],
      AI: ["anguillaLow", "anguillaHigh"],
      AG: ["antiguaBarbudaLow", "antiguaBarbudaHigh"],
      AR: ["argentinaLow", "argentinaHigh"],
      AM: ["armeniaLow", "armeniaHigh"],
      AW: ["arubaLow", "arubaHigh"],
      AU: ["australiaLow", "australiaHigh"],
      AT: ["austriaLow", "austriaHigh"],
      AZ: ["azerbaijanLow", "azerbaijanHigh"],
      BH: ["bahrainLow", "bahrainHigh"],
      BD: ["bangladeshLow", "bangladeshHigh"],
      BB: ["barbadosLow", "barbadosHigh"],
      BY: ["belarusLow", "belarusHigh"],
      BE: ["belgiumLow", "belgiumHigh"],
      BZ: ["belizeLow", "belizeHigh"],
      BJ: ["beninLow", "beninHigh"],
      BM: ["bermudaLow", "bermudaHigh"],
      BT: ["bhutanLow", "bhutanHigh"],
      BO: ["boliviaLow", "boliviaHigh"],
      BQ: ["bonaireSintEustatiusSabaLow", "bonaireSintEustatiusSabaHigh"],
      BA: [
        "bosniaHerzegovinaLow",
        "bosniaHerzegovinaHigh",
        "bosniaHerzegovinaCantonsLow",
        "bosniaHerzegovinaCantonsHigh",
      ],
      BW: ["botswanaLow", "botswanaHigh"],
      BR: ["brazilLow", "brazilHigh"],
      IO: ["britishIndianOceanTerritoryLow", "britishIndianOceanTerritoryHigh"],
      BN: ["bruneiDarussalamLow", "bruneiDarussalamHigh"],
      BG: ["bulgariaLow", "bulgariaHigh"],
      BF: ["burkinaFasoLow", "burkinaFasoHigh"],
      BI: ["burundiLow", "burundiHigh"],
      BS: ["bahamasLow", "bahamasHigh"],
      KH: ["cambodiaLow", "cambodiaHigh"],
      CM: ["cameroonLow", "cameroonHigh"],
      CA: ["canadaLow", "canadaHigh"],
      KY: ["caymanIslandsLow", "caymanIslandsHigh"],
      CV: ["capeVerdeLow", "capeVerdeHigh"],
      CF: ["centralAfricanRepublicLow", "centralAfricanRepublicHigh"],
      TD: ["chadLow", "chadHigh"],
      "GB-CHA": ["channelIslandsLow", "channelIslandsHigh"],
      CL: ["chileLow", "chileHigh"],
      CN: ["chinaLow", "chinaHigh"],
      CC: ["cocosKeelingLow", "cocosKeelingHigh"],
      CO: [
        "colombiaLow",
        "colombiaHigh",
        "colombiaMuniLow",
        "colombiaMuniHigh",
      ],
      KM: ["comorosLow", "comorosHigh"],
      CD: ["congoDRLow", "congoDRHigh"],
      CG: ["congoLow", "congoHigh"],
      CR: ["costaRicaLow", "costaRicaHigh"],
      HR: ["croatiaLow", "croatiaHigh"],
      CW: ["curacaoLow", "curacaoHigh"],
      CY: [
        "cyprusLow",
        "cyprusHigh",
        "cyprusNorthCyprusLow",
        "cyprusNorthCyprusHigh",
      ],
      CZ: ["czechiaLow", "czechiaHigh"],
      DK: ["denmarkLow", "denmarkHigh"],
      DJ: ["djiboutiLow", "djiboutiHigh"],
      DM: ["dominicaLow", "dominicaHigh"],
      DO: [
        "dominicanRepublicLow",
        "dominicanRepublicHigh",
        "dominicanRepublicMuniLow",
        "dominicanRepublicMuniHigh",
      ],
      EC: ["ecuadorLow", "ecuadorHigh"],
      EG: ["egyptLow", "egyptHigh"],
      SV: ["elSalvadorLow", "elSalvadorHigh"],
      GQ: ["equatorialGuineaLow", "equatorialGuineaHigh"],
      ER: ["eritreaLow", "eritreaHigh"],
      EE: ["estoniaLow", "estoniaHigh"],
      SZ: ["eswatiniLow", "eswatiniHigh"],
      ET: ["ethiopiaLow", "ethiopiaHigh"],
      FO: ["faroeIslandsLow", "faroeIslandsHigh"],
      FJ: ["fijiEastLow", "fijiEastHigh", "fijiWestLow", "fijiWestHigh"],
      FI: ["finlandLow", "finlandHigh"],
      FR: [
        "franceLow",
        "franceHigh",
        "franceDepartmentsLow",
        "franceDepartmentsHigh",
      ],
      GF: ["frenchGuianaLow", "frenchGuianaHigh"],
      GA: ["gabonLow", "gabonHigh"],
      GE: [
        "georgiaLow",
        "georgiaHigh",
        "georgiaSouthOssetiaLow",
        "georgiaSouthOssetiaHigh",
      ],
      DE: ["germanyLow", "germanyHigh"],
      GR: ["greeceLow", "greeceHigh"],
      GL: ["greenlandLow", "greenlandHigh"],
      GM: ["gambiaLow", "gambiaHigh"],
      GH: ["ghanaLow", "ghanaHigh"],
      GN: ["guineaLow", "guineaHigh"],
      GW: ["guineaBissauLow", "guineaBissauHigh"],
      GY: ["guyanaLow", "guyanaHigh"],
      HN: ["hondurasLow", "hondurasHigh"],
      HK: ["hongKongLow", "hongKongHigh"],
      HU: ["hungaryLow", "hungaryHigh"],
      IS: ["icelandLow", "icelandHigh"],
      IN: [
        "india2020Low",
        "india2020High",
        "india2019Low",
        "india2019High",
        "indiaLow",
        "indiaHigh",
      ],
      ID: ["indonesiaLow", "indonesiaHigh"],
      IE: ["irelandLow", "irelandHigh"],
      IL: [
        "israelLow",
        "israelHigh",
        "israelPalestineLow",
        "israelPalestineHigh",
      ],
      IT: ["italyLow", "italyHigh"],
      IQ: ["iraqLow", "iraqHigh"],
      IR: ["iranLow", "iranHigh"],
      JP: ["japanLow", "japanHigh"],
      KZ: ["kazakhstanLow", "kazakhstanHigh"],
      KE: ["kenyaLow", "kenyaHigh"],
      XK: ["kosovoLow", "kosovoHigh"],
      KW: ["kuwaitLow", "kuwaitHigh"],
      KG: ["kyrgyzstanLow", "kyrgyzstanHigh"],
      LA: ["laosLow", "laosHigh"],
      LV: ["latviaLow", "latviaHigh"],
      LI: ["liechtensteinLow", "liechtensteinHigh"],
      LT: ["lithuaniaLow", "lithuaniaHigh"],
      LU: ["luxembourgLow", "luxembourgHigh"],
      LY: ["libyaLow", "libyaHigh"],
      MG: [
        "madagascarProvinceLow",
        "madagascarProvinceHigh",
        "madagascarRegionLow",
        "madagascarRegionHigh",
      ],
      MY: ["malaysiaLow", "malaysiaHigh"],
      MR: ["mauritaniaLow", "mauritaniaHigh"],
      MV: [
        "maldivesLow",
        "maldivesHigh",
        "maldivesIslandsLow",
        "maldivesIslandsHigh",
      ],
      MW: ["malawiLow", "malawiHigh"],
      ML: ["maliLow", "maliHigh"],
      MT: ["maltaLow", "maltaHigh"],
      MX: ["mexicoLow", "mexicoHigh"],
      MD: ["moldovaLow", "moldovaHigh"],
      MN: ["mongoliaLow", "mongoliaHigh"],
      MA: ["moroccoLow", "moroccoHigh"],
      ME: ["montenegroLow", "montenegroHigh"],
      MZ: ["mozambiqueLow", "mozambiqueHigh"],
      MK: ["northMacedoniaLow", "northMacedoniaHigh"],
      MM: ["myanmarLow", "myanmarHigh"],
      NA: ["namibiaLow", "namibiaHigh"],
      NP: ["nepalLow", "nepalHigh"],
      NL: ["netherlandsLow", "netherlandsHigh"],
      NZ: ["newZealandLow", "newZealandHigh"],
      NI: ["nicaraguaLow", "nicaraguaHigh"],
      NE: ["nigerLow", "nigerHigh"],
      NG: ["nigeriaLow", "nigeriaHigh"],
      KP: ["northKoreaLow", "northKoreaHigh"],
      NO: ["norwayLow", "norwayHigh"],
      OM: ["omanLow", "omanHigh"],
      PK: ["pakistanLow", "pakistanHigh"],
      PS: ["palestineLow", "palestineHigh"],
      PA: ["panamaLow", "panamaHigh"],
      PE: ["peruLow", "peruHigh"],
      PH: ["philippinesLow", "philippinesHigh"],
      PL: ["polandLow", "polandHigh"],
      PT: [
        "portugalLow",
        "portugalHigh",
        "portugalRegionsLow",
        "portugalRegionsHigh",
      ],
      PR: ["puertoRicoLow", "puertoRicoHigh"],
      QA: ["qatarLow", "qatarHigh"],
      RO: ["romaniaLow", "romaniaHigh"],
      RU: ["russiaLow", "russiaHigh", "russiaCrimeaLow", "russiaCrimeaHigh"],
      RW: ["rwandaLow", "rwandaHigh"],
      SH: ["saintHelenaLow", "saintHelenaHigh"],
      LC: ["saintLuciaLow", "saintLuciaHigh"],
      VC: ["saintVincentLow", "saintVincentHigh"],
      WS: ["samoaLow", "samoaHigh"],
      SM: ["sanMarinoLow", "sanMarinoHigh"],
      SS: [
        "southSudanLow",
        "southSudanHigh",
        "southSudan2015Low",
        "southSudan2015High",
      ],
      ST: ["saoTomePrincipeLow", "saoTomePrincipeHigh"],
      SA: ["saudiArabiaLow", "saudiArabiaHigh"],
      SN: ["senegalLow", "senegalHigh"],
      RS: [
        "serbiaLow",
        "serbiaHigh",
        "serbiaNoKosovoLow",
        "serbiaNoKosovoHigh",
      ],
      SC: ["seychellesLow", "seychellesHigh"],
      SL: ["sierraLeoneLow", "sierraLeoneHigh"],
      SG: ["singaporeLow", "singaporeHigh"],
      SK: ["slovakiaLow", "slovakiaHigh"],
      SI: [
        "sloveniaLow",
        "sloveniaHigh",
        "sloveniaRegionsLow",
        "sloveniaRegionsHigh",
      ],
      SB: ["solomonIslandsLow", "solomonIslandsHigh"],
      SO: ["somaliaLow", "somaliaHigh"],
      ZA: ["southAfricaLow", "southAfricaHigh"],
      KR: ["southKoreaLow", "southKoreaHigh"],
      ES: ["spainLow", "spainHigh", "spainProvincesLow", "spainProvincesHigh"],
      LK: ["sriLankaLow", "sriLankaHigh"],
      KT: ["stKittsNevisLow", "stKittsNevisHigh"],
      PM: ["stPierreMiquelonLow", "stPierreMiquelonHigh"],
      SD: ["sudanLow", "sudanHigh"],
      SR: ["surinameLow", "surinameHigh"],
      SJ: ["svalbardLow", "svalbardHigh"],
      SE: ["swedenLow", "swedenHigh"],
      CH: ["switzerlandLow", "switzerlandHigh"],
      SY: ["syriaLow", "syriaHigh"],
      TJ: ["tajikistanLow", "tajikistanHigh"],
      TL: ["timorLesteLow", "timorLesteHigh"],
      TZ: ["tanzaniaLow", "tanzaniaHigh"],
      TH: ["thailandLow", "thailandHigh"],
      TG: ["togoLow", "togoHigh"],
      TN: ["tunisiaLow", "tunisiaHigh"],
      TR: ["turkeyLow", "turkeyHigh"],
      TM: ["turkmenistanLow", "turkmenistanHigh"],
      AE: ["uaeLow", "uaeHigh"],
      GB: [
        "ukLow",
        "ukHigh",
        "ukCountiesLow",
        "ukCountiesHigh",
        "ukCountriesLow",
        "ukCountriesHigh",
      ],
      UA: ["ukraineLow", "ukraineHigh"],
      US: [
        "usaLow",
        "usaHigh",
        "usaTerritoriesLow",
        "usaTerritoriesHigh",
        "usaTerritories2Low",
        "usaTerritories2High",
      ],
      UZ: ["uzbekistanLow", "uzbekistanHigh"],
      VA: ["vaticanLow", "vaticanHigh"],
      VE: ["venezuelaLow", "venezuelaHigh"],
      VN: ["vietnamLow", "vietnamHigh"],
      YE: ["yemenLow", "yemenHigh"],
      ZM: ["zambiaLow", "zambiaHigh"],
      ZW: ["zimbabweLow", "zimbabweHigh"],
    };
    map.logo.height = -1500;
    map.geodata = am4geodata_usaLow;
    map.projection = new am4maps.projections.Eckert6();
    
    // map.projection = new am4maps.projections.AlbersUsa();
    // map.legend = new am4maps.Legend();
    //defining polygon series
    let polygonSeries = map.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.heatRules.push({
      property: "fill",
      target: polygonSeries.mapPolygons.template,
      min: map.colors.getIndex(1).brighten(1),
      max: map.colors.getIndex(1).brighten(-0.3),
    });

    // Make map load polygon data (state shapes and names) from GeoJSON
    polygonSeries.useGeodata = true;
    polygonSeries.calculateVisualCenter = true;
    polygonSeries.mapPolygons.template.tooltipPosition = "fixed";
    // Set heatmap values for each state
    polygonSeries.data = [
      { id: "US-AL", value: 4447100 },
      { id: "US-AK", value: 626932 },
      { id: "US-AZ", value: 5130632 },
      { id: "US-AR", value: 2673400 },
      { id: "US-CA", value: 33871648 },
      { id: "US-CO", value: 4301261 },
      { id: "US-CT", value: 3405565 },
      { id: "US-DE", value: 783600 },
      { id: "US-FL", value: 15982378 },
      { id: "US-GA", value: 8186453 },
      { id: "US-HI", value: 1211537 },
      { id: "US-ID", value: 1293953 },
      { id: "US-IL", value: 12419293 },
      { id: "US-IN", value: 6080485 },
      { id: "US-IA", value: 2926324 },
      { id: "US-KS", value: 2688418 },
      { id: "US-KY", value: 4041769 },
      { id: "US-LA", value: 4468976 },
      { id: "US-ME", value: 1274923 },
      { id: "US-MD", value: 5296486 },
      { id: "US-MA", value: 6349097 },
      { id: "US-MI", value: 9938444 },
      { id: "US-MN", value: 4919479 },
      { id: "US-MS", value: 2844658 },
      { id: "US-MO", value: 5595211 },
      { id: "US-MT", value: 902195 },
      { id: "US-NE", value: 1711263 },
      { id: "US-NV", value: 1998257 },
      { id: "US-NH", value: 1235786 },
      { id: "US-NJ", value: 8414350 },
      { id: "US-NM", value: 1819046 },
      { id: "US-NY", value: 18976457 },
      { id: "US-NC", value: 8049313 },
      { id: "US-ND", value: 642200 },
      { id: "US-OH", value: 11353140 },
      { id: "US-OK", value: 3450654 },
      { id: "US-OR", value: 3421399 },
      { id: "US-PA", value: 12281054 },
      { id: "US-RI", value: 1048319 },
      { id: "US-SC", value: 4012012 },
      { id: "US-SD", value: 754844 },
      { id: "US-TN", value: 5689283 },
      { id: "US-TX", value: 20851820 },
      { id: "US-UT", value: 2233169 },
      { id: "US-VT", value: 608827 },
      { id: "US-VA", value: 7078515 },
      { id: "US-WA", value: 5894121 },
      { id: "US-WV", value: 1808344 },
      { id: "US-WI", value: 5363675 },
      { id: "US-WY", value: 493782 },
    ];

    polygonSeries.mapPolygons.template.events.on("hit", function (ev) {
      map.zoomToMapObject(ev.target);
    });

    // Configure series tooltip
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.applyOnClones = true;
    polygonTemplate.tooltipText = "{name}  : {value}";
    polygonTemplate.fill = am4core.color("#74B266");
    map.events.on("hit", () => {
      polygonSeries.heatRules.clear();
    });

    //For title of chart:

    // let title = chart.titles.create();
    // title.text =
    //   "[bold font-size: 20]Population of the World in 2011[/]\nsource: Gapminder";
    // title.textAlign = "middle";
  }
}
